<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Math Operator </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'type'" [label]="'Type'" [selectionPossibilities]="$typePossibilities()"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'inputA'" [label]="'Input A'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'inputB'" [label]="'Input B'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
